import { IApplicationState } from '../../../types/types';
import { IPushNotificationSettings } from '../pushNotificationSettings/types';

export const getPushNotificationSettingsByBoardId = (
    state: IApplicationState,
    boardId: number
): IPushNotificationSettings => {
    return state.model.pushNotificationsSettings[boardId];
};
